import * as Yup from "yup";

export const signUpSchema = Yup.object({
  name: Yup.string().min(2).max(25).required("Please enter your Name"),
  date: Yup.string().min(2).max(25).required("Please enter your Date"),
  fathername: Yup.number().required("Please enter your Amount"),
  address: Yup.string().email().required("Please enter your Address")
    
});